import { useParams } from "react-router-dom";
import { useEffect } from "react";

// Browser-source page. Renders the standalone overlay bundle in an iframe so
// the React app and the matter.js overlay stay decoupled.
export default function Overlay(): JSX.Element {
  const { streamKey } = useParams<{ streamKey: string }>();

  useEffect(() => {
    // OBS likes transparent backgrounds; force it on this route.
    document.body.style.background = "transparent";
    return () => { document.body.style.background = ""; };
  }, []);

  if (!streamKey) return <div>Missing stream key</div>;

  return (
    <iframe
      title="subswall-overlay"
      src={`/overlay/index.html?key=${encodeURIComponent(streamKey)}&v=${import.meta.env.VITE_BUILD_ID ?? Date.now()}`}
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100vh",
        border: 0,
        background: "transparent",
      }}
    />
  );
}
